import { safeRandomUUID } from "newui/utils/general";

const TAB_ID_KEY = "app:tab-id";

export function getTabId(forceRefresh = false): string {
	let tabId = sessionStorage.getItem(TAB_ID_KEY);

	if (!tabId || forceRefresh) {
		tabId = safeRandomUUID();
		sessionStorage.setItem(TAB_ID_KEY, tabId);
	}

	return tabId;
}
